import { createFileRoute, redirect } from '@tanstack/react-router';
import { toast } from 'react-hot-toast';

import { crownQueryClient } from '@/common/api/crownQueryClient';
import { requireAuthenticated } from '@/common/api/requireAuthenticated';
import { checkAuthQueryOptions } from '@/features/provider-panel/api/providerPanelApi';
import { ProviderPanel } from '@/features/provider-panel/ProviderPanel.tsx';
import { ErrorState } from '@/components/ui/states/ErrorState.tsx';

export const Route = createFileRoute('/provider/$providerId')({
  beforeLoad: async (params) => {
    await requireAuthenticated(params);
    try {
      await crownQueryClient.fetchQuery(
        checkAuthQueryOptions(params.params.providerId),
      );
    } catch {
      toast.error('You are not authorized to access this page', {
        id: 'unauthorized',
      });
      throw redirect({
        to: '/',
        replace: true,
      });
    }
  },
  head: () => ({ meta: [{ title: 'Provider Home' }] }),
  component: ProviderPanel,
  errorComponent: ErrorState,
  notFoundComponent: () => (
    <ErrorState error={"We couldn't find the page you were trying to reach"} />
  ),
});
